import { useCallback } from 'react';

import { FormContextValues } from '@dreryk/react-common';

import { medicalServiceTranslationKeys } from '../../../translations';

import { MedicalServiceName } from './name.types';

export const useNotUniqueMedicalServiceNameErrorHandler = (
   setError: FormContextValues<{ name: MedicalServiceName | null }>['setError']
): VoidFunction => {
   return useCallback(() => {
      setError('name', {
         message: medicalServiceTranslationKeys.shared.name.field.validate.notUniqueName,
      });
   }, [setError]);
};
